import {createFileRoute} from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/_layout/search/")({
	component: SearchScreen
});

function SearchScreen() {
	return <div></div>;
}
